import React, { useState } from "react";
import {
    commonService,
    AppConfigData,
} from "../_services/common.service";
import _Skeleton, { _SkeletonType } from "./_Skeleton";
import _NoDataFound from "./_NoDataFound";
import { useHistory } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import { alertService, AlertType } from "../_services/alert.service";
function SalarySlip() {
    const history = useHistory();
    let data = commonService.getLoginUserData();
    const [SalarySlip, setSalarySlip] = useState({ IsData: false, data: [] });


    function BindSalarySlipList() {
        setSalarySlip({ IsData: false, data: [] });

        const reqExam = {
            method: "POST",
            headers: commonService.getHeaders(),
        };
        fetch(AppConfigData.APIBasePath + "v1/fees/employeepublishedsalary", reqExam)
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    setSalarySlip({ IsData: true, data: json.data });
                } else if (json.status_code === 0) {
                    setSalarySlip({ IsData: true, data: [] });
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }







    React.useEffect(() => {
        if (commonService.getLoginRoleData("Salary Slip", "IsView") && data != null && data != undefined && data.length != 0 && data[0].MemberType.toLowerCase() === "teacher") {
            BindSalarySlipList();
        } else {
            history.push("/access");
        }
    }, []);

    function fnGenerateConsolidated() {
        let AllChk = document.getElementsByClassName("chkconselection");
        if (AllChk && AllChk.length > 0) {
            let SalaryTransactionIDs = "";
            for (let i = 0; i < AllChk.length; i++) {
                if (AllChk[i].checked) {
                    SalaryTransactionIDs = SalaryTransactionIDs + "," + AllChk[i].value;
                }
            }
            if (SalaryTransactionIDs && SalaryTransactionIDs !== "") {
                let URL = "http://erp.orataro.com/mobile_api/ConsolidatePaySlipView?c=" + data[0].ClientID +
                    "&i=" + data[0].InstituteID +
                    "&e=" + data[0].MemberID +
                    "&SalaryTransactionIDs=" + SalaryTransactionIDs +
                    "&PO=Portrait"
                window.open(URL, "_blank");
            }
            else {
                alertService.alert({
                    type: AlertType.Error,
                    message: "Select Salary Which You Want To Add In Consolidated",
                });
            }
        }
    }

    return (
        <>
            <h1 className="page-header my-4">{commonService.LabelDisplayText("MenuSalarySlip")} </h1>
            <div className="background-theme-color sticky-top">
                <div className="search-top-section">
                    <div className="row">
                        <div className="col-lg-8">
                            <b>For Consolidated Salary Certificate Select The Salary Which You Want To Add And Click On Generate Button</b>
                        </div>
                        <div className="col-lg-4 text-right">
                            <button className="btn btn-primary align-items-center justify-content-center" onClick={(e) => fnGenerateConsolidated()}>
                                {commonService.LabelDisplayText("GenerateConsolidated")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {!SalarySlip.IsData ? (
                <div className="row col-12">
                    <_Skeleton type={_SkeletonType.Table} count={4} lineheight={30} />
                </div>
            ) : SalarySlip.data.length === 0 ? (
                <div className="col-12">
                    <_NoDataFound fontsize={"150px"} />
                </div>
            ) : (
                <Table responsive className="fees-payment-table m-0">
                    <thead>
                        <tr>
                            <th className="w-150px">{commonService.LabelDisplayText("SalaryMonthYearName")}</th>
                            <th className="text-right w-150px">{commonService.LabelDisplayText("TotalSalary")}</th>
                            <th className="text-right w-150px">{commonService.LabelDisplayText("TotalAllowance")}</th>
                            <th className="text-right w-150px">{commonService.LabelDisplayText("TotalDeduction")}</th>
                            <th className="text-right w-150px">{commonService.LabelDisplayText("PayableSalary")}</th>
                            <th>{commonService.LabelDisplayText("EMPNote")}</th>
                            <th>{commonService.LabelDisplayText("GeneralNote")}</th>
                            <th className="w-75px">{commonService.LabelDisplayText("Action")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {SalarySlip.data.map(
                            (item, index) =>
                                <tr key={index}>
                                    <td><input type="checkbox" className={"chkconselection"} value={item.SalaryTransactionID} /> {item.SalaryMonthYearName}</td>
                                    <td className="text-right">{item.TotalSalary}</td>
                                    <td className="text-right">{item.TotalAllowance}</td>
                                    <td className="text-right">{item.TotalDeduction}</td>
                                    <td className="text-right">{item.PayableSalary}</td>
                                    <td>{item.EMPNote}</td>
                                    <td>{item.GeneralNote}</td>
                                    <td>
                                        <a
                                            target="_blank"
                                            href={
                                                "http://erp.orataro.com/mobile_api/PaySlipView?c=" + data[0].ClientID +
                                                "&i=" + data[0].InstituteID +
                                                "&e=" + data[0].MemberID +
                                                "&stdateofmonth=" + "01-" + item.SalaryMonthYearName +
                                                "&PO=Portrait"
                                            }
                                        >
                                            <button className="small-btn d-flex align-items-center justify-content-center">
                                                {commonService.LabelDisplayText("View")}
                                            </button>
                                        </a>
                                    </td>
                                </tr>
                        )}
                    </tbody>
                </Table>
            )}
        </>
    );
}

export default SalarySlip;
